
import React from "react";
import { Control } from "react-hook-form";
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Checkbox } from "@/components/ui/checkbox";
import { Textarea } from "@/components/ui/textarea";
import { Accessibility } from "lucide-react";
import { WaitlistFormValues, careNeeds } from "../schema";

interface SectionProps {
  control: Control<WaitlistFormValues>;
}

export function CareRequirementsSection({ control }: SectionProps) {
  return (
    <div className="bg-white p-6 rounded-lg shadow-sm border border-grandpal-beige">
      <h3 className="text-lg font-semibold mb-4 flex items-center gap-2">
        <Accessibility className="h-5 w-5 text-grandpal-green" />
        Care Requirements
      </h3>
      
      <FormField
        control={control}
        name="careNeeds"
        render={() => (
          <FormItem>
            <div className="mb-4">
              <FormLabel>Care Needs</FormLabel>
              <FormDescription>
                Select all that apply
              </FormDescription>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
              {careNeeds.map((item) => (
                <FormField
                  key={item.id}
                  control={control}
                  name="careNeeds"
                  render={({ field }) => {
                    return (
                      <FormItem
                        key={item.id}
                        className="flex flex-row items-start space-x-3 space-y-0"
                      >
                        <FormControl>
                          <Checkbox
                            checked={field.value?.includes(item.id)}
                            onCheckedChange={(checked) => {
                              return checked
                                ? field.onChange([...field.value, item.id])
                                : field.onChange(
                                    field.value?.filter(
                                      (value) => value !== item.id
                                    )
                                  )
                            }}
                          />
                        </FormControl>
                        <FormLabel className="font-normal">
                          {item.label}
                        </FormLabel>
                      </FormItem>
                    )
                  }}
                />
              ))}
            </div>
            <FormMessage />
          </FormItem>
        )}
      />
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
        <FormField
          control={control}
          name="careNeedsDetails"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Details about Care Needs</FormLabel>
              <FormControl>
                <Textarea 
                  placeholder="Please provide more details about specific care needs..."
                  className="min-h-20"
                  {...field} 
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        
        <FormField
          control={control}
          name="mobilityRequirements"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Mobility Requirements</FormLabel>
              <FormControl>
                <Textarea 
                  placeholder="Any specific mobility needs or challenges..."
                  className="min-h-20"
                  {...field} 
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
    </div>
  );
}
